import type { BaseResponse } from './base';
import { CategoryKindWithCharge } from './category';

export enum DailyDistributionMethod {
  DayOfWeek = 'day_of_week',
  Date = 'date',
}

export enum AllocationType {
  Amount = 'amount',
  Ratio = 'ratio',
}

export enum DayOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

export interface BudgetDateAllocation {
  id: number;
  budget_id: number;
  date: string;
  amount: number;
}

export interface BudgetRevenueCenterAllocation {
  revenue_center_id: number;
  ratio: number;
}

export interface BudgetCategoryAllocation {
  category_kind: CategoryKindWithCharge;
  ratio: number;
}

export interface BudgetDaypartingAllocation {
  dayparting_id: number;
  ratio: number;
}

export interface BudgetDayOfWeekAllocation {
  day_of_week: DayOfWeek;
  amount: number;
}

export interface BudgetAllocations {
  revenue_center_allocations?: BudgetRevenueCenterAllocation[];
  category_kind_allocations?: BudgetCategoryAllocation[];
  dayparting_allocations?: BudgetDaypartingAllocation[];
  day_of_week_allocations?: BudgetDayOfWeekAllocation[];
}

export interface Budget {
  id: number;
  uid: string;
  organization_id: number;
  shop_id: number;
  month: number;
  year: number;
  total_budget: number;
  allocations: BudgetAllocations;
  date_allocations?: BudgetDateAllocation[];
}

export interface BudgetListResponse extends BaseResponse<Budget[]> {}

export interface BudgetResponse extends BaseResponse<Budget> {}
